var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex flex-column flex-fill h-100 bg--white border-radius m-t-25 m-b-25 p-30",
      },
      [
        _c(
          "ak-form",
          _vm._g(
            {
              key: _vm.formKey,
              attrs: {
                bundle: _vm.bundle,
                definition: _vm.definition,
                objectId: _vm.objectId,
                relationString: _vm.relationString,
              },
              scopedSlots: _vm._u([
                {
                  key: "submit-button",
                  fn: function (ref) {
                    var form = ref.form
                    var submit = ref.submit
                    var baseUriControls = ref.baseUriControls
                    var setLoading = ref.setLoading
                    return [
                      form.footerWidgets && form.footerWidgets.widgets.length
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ak-button-group flex-row-reverse justify-content-end",
                              },
                              _vm._l(
                                form.footerWidgets.widgets,
                                function (widget) {
                                  return _c(
                                    "ak-widget",
                                    _vm._g(
                                      {
                                        key: widget.id,
                                        attrs: {
                                          slot: widget.slot,
                                          type: widget.type,
                                          callbacks: widget.callbacks,
                                          objectId: _vm.objectId,
                                          contextType:
                                            form.footerWidgets.contextType,
                                          callbackUri: baseUriControls,
                                          attributes: Object.assign(
                                            {},
                                            widget.attributes,
                                            {
                                              id: widget.id,
                                              baseUri: baseUriControls,
                                              relationString:
                                                _vm.relationString,
                                              currentObjectId: _vm.objectId,
                                            }
                                          ),
                                        },
                                        on: {
                                          submit: submit,
                                          "widget-event-callback-loading":
                                            setLoading,
                                        },
                                        slot: widget.slot,
                                      },
                                      _vm.$listeners
                                    )
                                  )
                                }
                              ),
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            _vm.$listeners
          )
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }